export default {

    /**
     * Converts a fee/currency string to an integer.
     * @param {(string|NaN)} num - a fee (e.g. '$1,000')
     * @returns {int}
     */
    parseCurrency(num) {
        if (num === null || num === '') {
            return 0;
        }
        if (!isNaN(num)) {
        // ensure num is an Number, not a String
            return parseInt(num, 10);
        }
        // remove everything but numbers (e.g. ₹ 100,000.00 => 100000, CA$ 789,199.45 => 789199.45)
        // more future friendly than adding our list of currencies in the regex
        return parseInt(num.replace(/[^0-9.]+/g, ''), 10);
    },

    // This method ensures enough precision for sub-cent values
    // Sets precision to 2 decimals
    // If < 10 cents, sets precision to 3 decimals
    adjustSubCentPrecision(num) {
        let total;
        if (num > 1) {
            total = num.toFixed(2);
            return total;
        }
        total = num.toFixed(3);
        // If there's no zero in tenths place, make it toFixed(2)
        const re = /\d\.(\d)/;
        const m = re.exec(total);
        if (m !== null) {
            if (m[1] !== '0') {
                total = parseFloat(total).toFixed(2);
            }
        }
        return total;
    },

    /**
     *
     * @param {String|Number} num
     * @param {Object} currency
     */
    formatCurrencyDisplay(num, currency) {
        try {
            const total = this.adjustSubCentPrecision(num);
            const formatOptions = {
                style: 'currency',
                currency: currency.key,
                minimumSignificantDigits: 1,
                minimumFractionDigits: 2
            };
            const formatter = new Intl.NumberFormat('en-US', formatOptions);
            let formattedCurrency = formatter.format(total);
            if (formattedCurrency.includes('.')) {
                const parts = formattedCurrency.split('.');
                if (parts[1].length === 1) {
                    formattedCurrency = `${formattedCurrency}0`;
                }
            }
            // Some currencies will not have a symbol implemented
            // by Intl.NumberFormat. In these cases it will
            // fallback to using the currency code as the prefix.
            // If this is the case, and we've been provided the symbol, replace the code with the symbol.
            // We assume that the currency code is being prepended to the string.
            if (currency.symbol && formattedCurrency.indexOf(currency.key) === 0) {
                formattedCurrency = formattedCurrency.replace(currency.key, currency.symbol);
            }
            return formattedCurrency;
        } catch (unusedError) {
            // if formatting fails return the provided num as is.
            return num;
        }
    },

    formatCurrencyExact(num) {
        const total = this.adjustSubCentPrecision(num);
        // Using USD to ensure the decimal separator instead of comma
        // since a comma would mess up CSV output, which is the main use
        // of this function
        const formatOptions = {
            style: 'currency',
            currency: 'USD',
            minimumSignificantDigits: 1,
            minimumFractionDigits: 2
        };
        const formatter = new Intl.NumberFormat('en-US', formatOptions);
        const parts = formatter.formatToParts(total);
        let formattedCurrency = parts.reduce((acc, cur) => {
            if (cur.type === 'integer'
        || cur.type === 'decimal'
        || cur.type === 'fraction') {
                return `${acc}${cur.value}`;
            }
            return acc;
        }, '');
        // Add back decimals to maintain at least 2 decimal precision
        if (!formattedCurrency.includes('.')) {
            formattedCurrency = `${formattedCurrency}.00`;
        }
        return formattedCurrency;
    }
};
